import { RequestService } from '../../../../../common/services/RequestService';
import { API_TARIFF_PRICES } from '../../constants';

export const getTariffPricesRequest = payload => {
  return RequestService.get(API_TARIFF_PRICES).then(response => response);
};
